// Chatbot lead code (?ref=...) from WhatsApp / Instagram links.
//
// The bot adds ?ref=<code> to every trip link it sends. We keep the code
// for 30 days and send it with analytics events, so the support team can
// see what this chat lead did on the website (viewed trip, checkout, paid).
// The code is removed from the address bar so it isn't shared by accident.

const KEY = 'trvto_lead_ref';
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000;
const PATTERN = /^[A-Za-z0-9_-]{20}$/;

/** Call once when the site loads (before the router reads the URL). */
export const captureLeadRef = () => {
    try {
        const url = new URL(window.location.href);
        const ref = url.searchParams.get('ref');
        if (!ref || !PATTERN.test(ref)) return;

        localStorage.setItem(KEY, JSON.stringify({ ref, at: Date.now() }));

        url.searchParams.delete('ref');
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (e) {
        // storage blocked / old browser — tracking is optional
    }
};

/** The saved code if it is less than 30 days old, otherwise null. */
export const getLeadRef = () => {
    try {
        const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (!saved?.ref || Date.now() - saved.at > MAX_AGE_MS) return null;
        return saved.ref;
    } catch (e) {
        return null;
    }
};
